module.exports = __webpack_public_path__ + "static/assets/da651c4aad54932d9ccac36246769c14.svg";